import merge from 'deepmerge';
import specs from '../specs/specs';
// TODO: how to have access to IDefinition
export function renderChart(elementId, definition, data) {
    if (definition.type === 'custom') {
        var chart_1 = AmCharts.makeChart(elementId, definition.specification);
        return chart_1;
    }
    // Clone/copy spec and data
    // Longer than normal conditional so setting as its own const
    var hasSpecAndIsntString = definition.specification && typeof definition.specification !== 'string';
    // ternary checking to see if there is a def.spec and that it is NOT a string (url)
    // if true than return def.spec. If not true than fetch a premade spec
    var spec = hasSpecAndIsntString ? clone(definition.specification) : fetchSpec(definition.type);
    var copyData = clone(data);
    // Set the spec's data
    spec.dataProvider = copyData;
    // Apply the series
    if (!!definition.datasets) {
        spec = fillInSpec(spec, definition);
    }
    // Apply overrides
    if (definition.overrides) {
        // NOTE: this counts on using deepmerge < 2.x
        // see: https://github.com/KyleAMathews/deepmerge#arraymerge
        spec = merge(spec, definition.overrides, { clone: true });
    }
    var chart = AmCharts.makeChart(elementId, spec);
    // If it is a pie chart
    if (definition.type === 'pie') {
        // Set pie chart balloonText
        chart.balloonText = getPieBalloonText(definition);
    }
    return chart;
}
function getPieBalloonText(definition) {
    // Set label based on whether or not there actually is a category label
    var categoryLabel = !!definition.series[0].category.label ? definition.series[0].category.label + ": " : '';
    // Set label based on whether or not there actually is a value label
    var valueLabel = !!definition.series[0].value.label ? definition.series[0].value.label + ": " : '';
    // return balloonText
    return "<div>" + categoryLabel + "[[title]]</div><div>" + valueLabel + "[[percents]]% ([[value]])</div>";
}
export function fillInSpec(spec, definition) {
    // Grab the graphSpec from the spec
    var graphSpec = spec.graphs.pop();
    var isJoined = definition.datasets.length > 1;
    // category field will be 'categoryField' in the case of joined datasets
    // otherwise get it from the first series
    spec.categoryField = isJoined ? 'categoryField' : definition.series[0].category.field;
    // Set tabIndex for the chart
    spec.tabIndex = 0;
    // Add a legend in case it's not on the spec
    if (!spec.legend) {
        spec.legend = {};
    }
    // TODO This is needed as 'legend.enable' has been renamed 'legend.visible'. We are only introducing
    // breaking changes on major releases.
    // Remove the line below on next breaking change
    /* istanbul ignore next since we're going to remove this */
    if (definition.legend && definition.legend.hasOwnProperty('enable')) {
        definition.legend.visible = definition.legend.enable;
    }
    // adjust legend and axis labels for single series charts
    if (definition.series.length === 1 && (definition.type !== 'pie' && definition.type !== 'radar')) {
        // don't show legend by default for single series charts
        spec.legend.enabled = false;
        // get default axis labels from series
        var categoryAxisTitle_1 = definition.series[0].category.label;
        var valueAxisTitle_1 = definition.series[0].value.label;
        if (spec.type === 'xy' && Array.isArray(spec.valueAxes)) {
            // for xy charts we treat the x axis as the category axis
            // and the y axis as the value axis
            spec.valueAxes.forEach(function (axis) {
                /* istanbul ignore else since we can only be smart about bottom/left axis labels */
                if (axis.position === 'bottom') {
                    axis.title = categoryAxisTitle_1;
                }
                else if (axis.position === 'left') {
                    axis.title = valueAxisTitle_1;
                }
            });
        }
        else {
            // line/area specs don't define axes
            if (!spec.valueAxes) {
                spec.valueAxes = [{}];
            }
            spec.valueAxes[0].title = definition.series[0].value.label;
            spec.valueAxes[0].position = 'left';
            /* istanbul ignore else until we have a test for a timeline definition/spec */
            if (!spec.categoryAxis) {
                spec.categoryAxis = {};
            }
            spec.categoryAxis.title = categoryAxisTitle_1;
        }
    }
    // Handle Legend in case.
    if (definition.legend) {
        var legend = definition.legend;
        var supportedLegendPositions = ['top', 'bottom', 'left', 'right'];
        if (legend.hasOwnProperty('visible')) {
            spec.legend.enabled = legend.visible;
            // If there is a legend on the page add a tabIndex
            spec.legend.tabIndex = 0;
        }
        if (legend.position && supportedLegendPositions.indexOf(legend.position) > -1) {
            spec.legend.position = legend.position;
        }
    }
    // Handle styles...
    /* istanbul ignore if */
    if (definition.style) {
        // snag out style
        var style = definition.style;
        // handle margins
        /* istanbul ignore if */
        if (style.padding) {
            var padding = style.padding;
            // Assume we need to set auto margins false
            spec.autoMargins = false;
            if (padding.hasOwnProperty('top')) {
                spec.marginTop = padding.top;
            }
            if (padding.hasOwnProperty('bottom')) {
                spec.marginBottom = padding.bottom;
            }
            if (padding.hasOwnProperty('left')) {
                spec.marginLeft = padding.left;
            }
            if (padding.hasOwnProperty('right')) {
                spec.marginRight = padding.right;
            }
        }
        // If there is a pie property
        /* istanbul ignore if */
        if (style.pie) {
            var pie = style.pie;
            // A range from 0 - n where n is the inner radius of the pie chart. Anything above a 0
            // turns the chart into a donut chart. Can be a number for pixels or a percent.
            if (pie.hasOwnProperty('innerRadius')) {
                spec.innerRadius = pie.innerRadius;
            }
            // How far a pie chart slice will pull out when selected. Can be a number for pixels or a percent
            if (pie.hasOwnProperty('expand')) {
                spec.pullOutRadius = pie.expand;
            }
        }
        if (style.colors && Array.isArray(style.colors)) {
            spec.colors = style.colors;
        }
    }
    // Iterate over datasets
    definition.datasets.forEach(function (dataset, d) {
        var datasetName = dataset.name;
        // For each dataset iterate over series
        definition.series.forEach(function (series, s) {
            if (dataset.name === series.source) {
                var graph = clone(graphSpec);
                // use the value field label for the graph's title
                graph.title = series.value.label;
                // value field will contain dataset name if joined
                graph.valueField = isJoined ? datasetName + "_" + series.value.field : series.value.field;
                // TODO: map other fields besides value like color, size, etc
                // tooltip
                graph.balloonText = "<div>" + series.category.label + ": [[" + spec.categoryField + "]]</div><div>" + graph.title + ": [[" + graph.valueField + "]]</div>";
                // Group vs. stack
                if (!!series.stack && graph.newStack) {
                    graph.newStack = false;
                }
                // special props for pie charts
                if (definition.type === 'pie') {
                    spec.titleField = spec.categoryField;
                    spec.valueField = graph.valueField;
                }
                // special props for x/y types (scatter, bubble)
                if (spec.type === 'xy' && !!series.category && !!series.value) {
                    graph.xField = series.category.field;
                    graph.yField = series.value.field;
                    graph.balloonText = "<div>" + series.category.label + ": [[" + series.category.field + "]]</div><div>" + series.value.label + ": [[" + series.value.field + "]]</div>";
                    // bubble
                    if (spec.type === 'xy' && series.size) {
                        graph.valueField = series.size.field;
                        graph.balloonText = graph.balloonText + "<div>" + series.size.label + ": [[" + graph.valueField + "]]</div>";
                    }
                    else {
                        delete graph.valueField;
                    }
                }
                spec.graphs.push(graph);
            }
        });
    });
    return spec;
}
export function fetchSpec(type) {
    var spec = type;
    if (spec === 'time') {
        console.warn("'time' is no longer a supported type. Please use 'timeline' instead");
        spec = 'timeline';
    }
    else if (spec === 'bubble') {
        console.warn("'bubble' is no longer a supported type. Please use 'scatter' instead");
        spec = 'scatter';
    }
    else if (spec === 'grouped') {
        console.warn("'grouped' is no longer a supported type. Please use 'bar' instead");
        spec = 'bar';
    }
    return clone(specs[spec]);
}
function clone(json) {
    return JSON.parse(JSON.stringify(json));
}
// TODO: remove
var render = {
    renderChart: renderChart,
    fillInSpec: fillInSpec,
    fetchSpec: fetchSpec
};
export default render;
//# sourceMappingURL=render.js.map